import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import Overview from "./Overview";

const Business = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    city: "",
    medicalCondition: "",
    smoker: "",
    numberOfAdults: "1",
    numberOfChildren: "0",
    coverageAmount: "500000",
    termsAccepted: false,
  });

  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      city: "",
      medicalCondition: "",
      smoker: "",
      numberOfAdults: "1",
      numberOfChildren: "0",
      coverageAmount: "500000",
      termsAccepted: false,
    });
    setValidated(false);
    setShowSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        // 👇 Call your API here
        const response = await fetch("https://your-api-url.com/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        console.log("Form data submitted successfully:", formData);
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          resetForm();
        }, 3000);
      } catch (error) {
        console.error("Error submitting form data:", error);
      }
    }
    setValidated(true);
  };

  const gender = ["Others", "Male", "Female"];

  const cities = [
    "Bangalore",
    "Mumbai",
    "Delhi",
    "Chennai",
    "Hyderabad",
    "Kolkata",
    "Pune",
  ];
  const state = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="main-box">
        <div className="row ">
          <div className="main-box-ss">
            <div className="col-12 col-md-12">
              <section className="insurance-service position-relative overflow-hidden">
                <div className="radial-bg"></div>

                <div
                  className="insurance position-relative"
                  style={{ zIndex: 1 }}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12 d-flex justify-content-end pt-3 px-3 px-md-5"></div>
                    </div>

                    <div
                      className="row justify-content-center align-items-center text-center"
                    >
                      <div className="col-12 mb-3 mt-5 pb-0">
                        <h2 className="fw-bold carloan-text-1 mb-2">
                          Business Insurance
                        </h2>
                        <p className="mb-0">
                          To apply for a Business Insurance, Please fill all the
                          details.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{
                    filter: "blur(88px)",
                    zIndex: 0,
                  }}
                ></div>

                <div className="container mt-5 mt-lg-0">
                  <div className="row mb-4 justify-content-center">
                    <div className="col-12 col-lg-12">
                      <div className="card card_top border-0 ">
                        <div
                          className="card-body   bg-light"
                          style={{
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          {showSuccess && (
                            <div className="alert alert-success" role="alert">
                              Your Business insurance application has been
                              submitted successfully!
                            </div>
                          )}

                          <form
                            className={validated ? "was-validated" : ""}
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                          >
                            <div className="card mb-4">
                              <div className="card-body">
                                <h5 className="mb-4">
                                  Business Insurance Details
                                </h5>
                                <div className="row">
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="businessName">
                                        Business Name
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="businessName"
                                        name="businessName"
                                        placeholder="Enter business name"
                                        value={formData.businessName}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please enter the business name.
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="businessType">
                                        Business Type
                                      </label>
                                      <select
                                        className="form-select"
                                        id="businessType"
                                        name="businessType"
                                        value={formData.businessType}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        <option value="Sole Proprietorship">
                                          Sole Proprietorship
                                        </option>
                                        <option value="Partnership">
                                          Partnership
                                        </option>
                                        <option value="Pvt Ltd">
                                          Private Limited
                                        </option>
                                        <option value="LLP">LLP</option>
                                        <option value="Others">Others</option>
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select a business type.
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="industryType">
                                        Industry Type
                                      </label>
                                      <select
                                        className="form-select"
                                        id="industryType"
                                        name="industryType"
                                        value={formData.industryType}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        <option value="Manufacturing">
                                          Manufacturing
                                        </option>
                                        <option value="Retail">Retail</option>
                                        <option value="IT">IT</option>
                                        <option value="Healthcare">
                                          Healthcare
                                        </option>
                                        <option value="Logistics">
                                          Logistics
                                        </option>
                                        <option value="Hospitality">
                                          Hospitality
                                        </option>
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select an industry type.
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="turnover">
                                        Annual Turnover (INR)
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        id="turnover"
                                        name="turnover"
                                        placeholder="e.g., 5000000"
                                        value={formData.turnover}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please enter annual turnover.
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-12 col-md-4 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="employees">
                                        Number of Employees
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        id="employees"
                                        name="employees"
                                        placeholder="e.g., 50"
                                        value={formData.employees}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please enter number of employees.
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-4 mb-3">
                                    <div className="form-group">
                                      <label htmlFor="insuranceCoverage">
                                        Required Insurance Coverage
                                      </label>
                                      <select
                                        className="form-select"
                                        id="insuranceCoverage"
                                        name="insuranceCoverage"
                                        value={formData.insuranceCoverage}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select</option>
                                        <option value="Public Liability">
                                          Public Liability
                                        </option>
                                        <option value="Product Liability">
                                          Product Liability
                                        </option>
                                        <option value="Fire Insurance">
                                          Fire Insurance
                                        </option>
                                        <option value="Business Interruption">
                                          Business Interruption
                                        </option>
                                        <option value="Cyber Insurance">
                                          Cyber Insurance
                                        </option>
                                        <option value="Marine Insurance">
                                          Marine Insurance
                                        </option>
                                      </select>
                                      <div className="invalid-feedback">
                                        Please select an insurance coverage
                                        type.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-4 mb-3">
                                    <div className="form-group mb-3">
                                      <label htmlFor="sumInsured">
                                        Sum Insured (INR)
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        id="sumInsured"
                                        name="sumInsured"
                                        placeholder="e.g., 10000000"
                                        value={formData.sumInsured}
                                        onChange={handleChange}
                                        required
                                      />
                                      <div className="invalid-feedback">
                                        Please provide a valid amount.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="termsAccepted"
                                    name="termsAccepted"
                                    checked={formData.termsAccepted}
                                    onChange={handleChange}
                                    required
                                  />
                                  <span>
                                    By submitting the application, I agree and
                                    accept the Terms and Conditions as specified{" "}
                                    <a href="/" className="text-primary">
                                      here
                                    </a>
                                  </span>
                                  <div className="invalid-feedback">
                                    You must accept the terms and conditions.
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-m py-2"
                                >
                                  Apply
                                </button>
                                &nbsp;&nbsp;&nbsp;
                                <button
                                  className="btn btn-primary py-2 btn-m"
                                  onClick={resetForm}
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default Business;
